/**
 * The token a SaaS entry brings in the URL (`?token=`, `?access_token=`,
 * or the same in the hash), read once at boot.
 *
 * The API client adopts a search-part token on its first request and strips
 * it from the URL. When that request comes before the app's init (the boot
 * prefetch, D-06), init would no longer find the token and would not hand it
 * to the SaaS client (review of web #72). Init therefore also asks here, once.
 */

let captured: string | null = null;

export const readUrlToken = (
  location: Pick<Location, 'search' | 'hash'>,
): string | null => {
  const search = new URLSearchParams(location.search);
  const fromSearch = search.get('token') || search.get('access_token');
  if (fromSearch) return fromSearch;
  if (!location.hash) return null;
  const hash = new URLSearchParams(location.hash.replace(/^#/, ''));
  return hash.get('access_token') || hash.get('token') || null;
};

/** Read the URL's token before anything can strip it (main.tsx). */
export const captureBootUrlToken = (
  location: Pick<Location, 'search' | 'hash'> = window.location,
): string | null => {
  captured = readUrlToken(location);
  return captured;
};

/** The captured token, once (init.tsx, when the URL no longer has it). */
export const consumeBootUrlToken = (): string | null => {
  const token = captured;
  captured = null;
  return token;
};
